import { createError } from '@adv-frontend/error';

export const RumError = createError('RumError');
